import { h } from '@stencil/core';
export class ExpandableList {
  constructor() {
    this.multiple = undefined;
  }
  onExpandableChanged(e) {
    if (e.detail && !this.multiple) {
      this.el.querySelectorAll('oebbx-expandable-item').forEach(item => {
        if (item !== e.target) {
          item.close().then();
        }
      });
    }
  }
  render() {
    return (h("ul", { class: "expandable-list" }, h("slot", null)));
  }
  static get is() { return "oebbx-expandable-list"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["expandable-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["expandable-list.css"]
    };
  }
  static get properties() {
    return {
      "multiple": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "multiple",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "expandableOpened",
        "method": "onExpandableChanged",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=expandable-list.js.map
